<mat-form-field class="dict-termianls-import-row-balance">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="terminalsImportRowFilterCtrl" placeholderLabel="ID"
                             noEntriesFoundLabel="Nie znaleziono transakcji">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items"
                [value]="option.id">
      {{option.id}}     [ {{  option.transferAmount  }}  zł]
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
